import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getAllCountrySync } from "../../services/MoloniServices";
import "bootstrap-icons/font/bootstrap-icons.css";

const MoloniSettings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isCountryLoading, setIsCountryLoading] = useState(false);
  const isApp = Number(localStorage.getItem("isApp"));

  const handleCountrySync = () => {
    setIsCountryLoading(true);

    let data = { company_id: "269134" };

    getAllCountrySync(data)
      .then((response) => {
        setIsCountryLoading(false);
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsCountryLoading(false);
      });
  };

  const data = [
    { id: 1, name: "bankAccounts", icon: "bi-bank" },
    { id: 2, name: "caeCodes", icon: "bi-code" },
    { id: 3, name: "paymentMethods", icon: "bi-credit-card" },
    { id: 4, name: "maturityDates", icon: "bi-calendar2-week" },
    { id: 5, name: "deliveryMethods", icon: "bi-truck" },
    { id: 6, name: "vehicles", icon: "bi-car-front" },
    { id: 7, name: "deductions", icon: "bi-dash-circle" },
    { id: 8, name: "taxAndFees", icon: "bi-receipt" },
    { id: 9, name: "measurementUnits", icon: "bi-rulers" },
    { id: 10, name: "identificationTemplates", icon: "bi-file-earmark-person" },
    { id: 11, name: "documentSets", icon: "bi-journal-text" },
    { id: 12, name: "warehouses", icon: "bi-box-seam" },
    { id: 13, name: "productProperties", icon: "bi-tags" },
    { id: 14, name: "currency", icon: "bi-currency-dollar" },
  ];

  return (
    <div>
      <section className="content-header content-header-custom">
        <div className="container-fluid container-custom-height-new">
          <div className="row mb-2">
            <div className="col-sm-12 d-flex align-items-center">
              <button
                type="button"
                className="next-button btn btn-secondary"
                onClick={() => navigate("/moloni")}
              >
                <i className="bi bi-arrow-left"></i> {t("back")}
              </button>

              <button
                type="button"
                className="btn btn-icon-text mr-2 mt-2 mt-lg-0"
                style={{ marginLeft: "10px" }}
                onClick={handleCountrySync}
                disabled={isCountryLoading}
              >
                <i className="bi bi-arrow-repeat"></i>
                <span className="ms-2">
                  {isCountryLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Sync Country...
                    </>
                  ) : (
                    t("sync_country")
                  )}
                </span>
              </button>

              <h1 className="page-title ms-auto mb-2">{t("settings")}</h1>
            </div>

          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid container-custom-height-new">
          <div className="card bg-transparent shadow-none">
            <div className="col-md-12 list-group list-group-custom">
              {data.map((item) => (
                <li key={item.id} className="list-group-item">
                  <Link
                    className="d-flex align-items-center"
                    to={`/${item.name}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <i className={`icon-moloni bi ${item.icon} me-2`}></i>
                    {t(item.name)}
                  </Link>
                </li>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MoloniSettings;
